// typescript
import React from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import InputMask from '@mona-health/react-input-mask';

// cast genérico para transformar qualquer componente em React.ComponentType<any>
export const asAny = <T, >(comp: T): React.ComponentType<any> =>
    comp as unknown as React.ComponentType<any>;

// exports prontos
export const DragDropContextAny = asAny(DragDropContext);
export const DroppableAny = asAny(Droppable);
export const DraggableAny = asAny(Draggable);
export const InputMaskAny = asAny(InputMask);
export const ReactInputMaskAny = asAny(InputMask);
export const CopyToClipboardAny = asAny(InputMask);